<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { toast_message, toast_message_error } from "../stores.js";
    import { BASE_API_URL } from "../config.js";
    import { user_role } from "../scripts/auth.js";
    import SegmentControl2 from "../components/SegmentControl2.svelte";
    import { get_customer_list} from "../scripts/data.js";


    let form;
    const blocked_domains = [
        "@gmail.com", "@gmail.de",
        "@yahoo.com", "@yahoo.de",
        "@hotmail.com", "@hotmail.de",
        "@outlook.com", "@outlook.de",
        "@aol.com", "@aol.de",
        "@icloud.com", "@icloud.de",
        "@mail.com", "@mail.de",
        "@zoho.com", "@zoho.de",
        "@protonmail.com", "@protonmail.de",
        "@gmx.com", "@gmx.de",
        "@yandex.com", "@yandex.de",
        "@live.com", "@live.de",
        "@msn.com", "@msn.de",
        "@comcast.net", "@comcast.de",
        "@verizon.net", "@verizon.de",
        "@att.net", "@att.de",
        "@me.com", "@me.de",
        "@mac.com", "@mac.de",
        "@qq.com", "@qq.de",
        "@naver.com", "@naver.de",
        "@163.com", "@163.de",
        "@126.com", "@126.de",
        "@sina.com", "@sina.de",
        "@sohu.com", "@sohu.de",
        "@rediffmail.com", "@rediffmail.de",
        "@tutanota.com", "@tutanota.de",
        "@hushmail.com", "@hushmail.de",
        "@fastmail.com", "@fastmail.de",
        "@inbox.com", "@inbox.de",
        "@mail.ru", "@mail.de"
    ];
    let customer_name = "",
        customer_domain = "",
        customer_email = "",
        customer_number = "";

    let name_valid = false,
        domain_valid = false,
        email_valid = false,
        tried_submitting = false;

    let user_has_create_customer_permission =
        $user_role["create_customer"] && $user_role["create_customer"] == 1
            ? true
            : false;

    const SEGMENTS = {
        WITH_DOMAIN: "mit Domain",
        WITHOUT_DOMAIN: "ohne Domain",
    };
    let chosen_segment = SEGMENTS.WITH_DOMAIN;

    // Regex for email domain
    const REGEX = /^@\S+\.\S+$/; //TODO: keine doppelten @ oder .

    // Regex for email
    const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    /**
     * API call to save the customer.
     */
    async function save_customer() {
        let url_extension = `/customers/`;
        let request_url = BASE_API_URL + url_extension;

        let post_data = {
            name: customer_name.trim(),
            domain: customer_domain.trim() != "" ? customer_domain.trim() : null,
            email: customer_email.trim() != "" ? customer_email.trim() : null,
            number: customer_number.trim() != "" ? customer_number.trim() : null,
        };
        try {
            let response = await fetch(request_url, {
                method: "POST",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(post_data),
            });
            if (response.status == 201) {
                get_customer_list();
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    // form submit function
    async function handle_submit(event) {
        event.preventDefault(); // prevent autosubmit with bad data
        if (form.checkValidity() && name_valid && (domain_valid || email_valid)) {
            if (blocked_domains.includes(customer_domain.trim())) {
                toast_message_error.set(" Diese Domain ist gesperrt.");
                return;
            }
            const response = await save_customer();
            if (response) {
                customer_name = "";
                customer_domain = "";
                customer_number = "";
                customer_email = "";
                toast_message.set(" Kunde erfolgreich angelegt.");
            } else {
                toast_message_error.set(" Fehler beim Anlegen des Kunden.");
            }
            tried_submitting = false;
        } else {
            tried_submitting = true;
        }
    }

    function validate_name(customer_name) {
        return customer_name.trim().length > 1;
    }
    function validate_domain(customer_domain) {
        return REGEX.test(customer_domain.trim());
    }
    function validate_email(customer_email) {
        return EMAIL_REGEX.test(customer_email.trim().toLowerCase());
    }

    // Reactive validation of inputs
    $: name_valid = validate_name(customer_name);
    $: domain_valid = validate_domain(customer_domain);
    $: email_valid = validate_email(customer_email);

    // Reset hidden input when switching between segments
    $: {
        if (chosen_segment == SEGMENTS.WITH_DOMAIN) {
            customer_email = "";
        } else {
            customer_domain = "";
        }
    }
</script>

<span class="p-kachel-small primary-color text-left pt-2 pb-3">
    Kunden anlegen <span class="tooltip-container ml-1">
        <i class="fa-solid fa-circle-info fa-xs" style="color:#AFDDF2;"></i>
        <div class="tooltip">
            Ein Kunde kann entweder mit einer Domain, oder einer einzelnen Email
            Adresse erstellt werden.
        </div>
    </span>
</span>
<form bind:this={form} on:submit={handle_submit} novalidate>
    <SegmentControl2
        bind:chosen_segment
        bind:disabled={user_has_create_customer_permission}
        segments={[SEGMENTS.WITH_DOMAIN, SEGMENTS.WITHOUT_DOMAIN]}
    />

    {#if chosen_segment == SEGMENTS.WITH_DOMAIN}
        <div class="mb-3 mt-3">
            <label for="customer_domain_input" class="form-label primary-color"
                >Email Domain</label
            >
            <div class="input-group">
                <input
                    bind:value={customer_domain}
                    class="form-control py-1 {tried_submitting
                        ? domain_valid
                            ? 'is-valid'
                            : 'is-invalid'
                        : ''} {user_has_create_customer_permission
                        ? ''
                        : 'custom-disabled'}"
                    style="border-width: 2px"
                    type="text"
                    placeholder="Bsp: @2kai.eu"
                    aria-label="Search"
                    maxlength="32"
                    autocomplete="off"
                    required
                    id="customer_domain_input"
                />
                {#if customer_domain != ""}
                    <button
                        class="btn bg-transparent btn-clear2"
                        style="border-radius:0.25rem"
                        type="button"
                        on:click={() => (customer_domain = "")}
                    >
                        <i class="fa fa-times"></i>
                    </button>
                {/if}
            </div>
            {#if tried_submitting && !domain_valid}
                <div
                    class="invalid-feedback"
                    style="display:block; font-size:90%;"
                >
                    Bitten eine gültige Domain eingeben.
                </div>
            {/if}
        </div>
    {/if}

    {#if chosen_segment == SEGMENTS.WITHOUT_DOMAIN}
        <div class="mb-3 mt-3">
            <label for="customer_email_input" class="form-label primary-color"
                >Email Adresse</label
            >
            <div class="input-group">
                <input
                    bind:value={customer_email}
                    class="form-control py-1 {tried_submitting
                        ? email_valid
                            ? 'is-valid'
                            : 'is-invalid'
                        : ''} {user_has_create_customer_permission
                        ? ''
                        : 'custom-disabled'}"
                    style="border-width: 2px"
                    type="text"
                    placeholder="Bsp: M.Mustermann@2kai.eu"
                    aria-label="Search"
                    maxlength="64"
                    autocomplete="off"
                    required
                    id="customer_email_input"
                />
                {#if customer_email != ""}
                    <button
                        class="btn bg-transparent btn-clear2"
                        style="border-radius:0.25rem"
                        type="button"
                        on:click={() => (customer_email = "")}
                    >
                        <i class="fa fa-times"></i>
                    </button>
                {/if}
            </div>
            {#if tried_submitting && !email_valid}
                <div
                    class="invalid-feedback"
                    style="display:block; font-size:90%;"
                >
                    Bitten eine gültige Email eingeben.
                </div>
            {/if}
        </div>
    {/if}

    <div class="mb-3">
        <label for="customer_name_input" class="form-label primary-color">Name</label>
        <div class="input-group">
            <input
                bind:value={customer_name}
                class="form-control py-1 {tried_submitting
                    ? name_valid
                        ? 'is-valid'
                        : 'is-invalid'
                    : ''} {user_has_create_customer_permission
                    ? ''
                    : 'custom-disabled'}"
                style="border-width: 2px"
                type="text"
                maxlength="32"
                autocomplete="off"
                required
                id="customer_name_input"
            />
            {#if customer_name != ""}
                <button
                    class="btn bg-transparent btn-clear2"
                    style="border-radius:0.25rem"
                    type="button"
                    on:click={() => (customer_name = "")}
                >
                    <i class="fa fa-times"></i>
                </button>
            {/if}
        </div>
        {#if tried_submitting && !name_valid}
            <div class="invalid-feedback" style="display:block; font-size:90%;">
                Bitten einen Namen eingeben.
            </div>
        {/if}
    </div>

    <div class="mb-3">
        <label for="customer_number_input" class="form-label primary-color"
            >Kundennummer</label
        >
        <div class="input-group">
            <input
                bind:value={customer_number}
                class="form-control py-1 {user_has_create_customer_permission
                    ? ''
                    : 'custom-disabled'}"
                style="border-width: 2px"
                type="text"
                maxlength="32"
                autocomplete="off"
                id="customer_number_input"
            />
            {#if customer_number != ""}
                <button
                    class="btn bg-transparent btn-clear2"
                    style="border-radius:0.25rem"
                    type="button"
                    on:click={() => (customer_number = "")}
                >
                    <i class="fa fa-times"></i>
                </button>
            {/if}
        </div>
    </div>

    <div class="input-group mt-4">
        <button
            type="submit"
            class="btn btn-primary"
            disabled={!user_has_create_customer_permission}
        >
            Kunden anlegen
        </button>
    </div>
</form>
